/**
 * The recommended way to deep clone an object is to serialize and deserialize it again.
 * Note: this works only with serializable objects.
 */
export function deepClone<T>(input: T): T {
  return JSON.parse(JSON.stringify(input));
}
